/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  REINVITE_DIRECTOR: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.reinviteDirector',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'REINVITE_DIRECTOR' },
      },
    },
    REINVITE_DIRECTOR: {
      invoke: {
        id: 'reinviteDirector',
        src: 'reinviteDirector',
        onDone: {
          target: 'REINVITE_DIRECTOR_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'REINVITE_DIRECTOR_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    REINVITE_DIRECTOR_SUCCESS: {
      on: {
        START: { target: 'REINVITE_DIRECTOR' },
      },
    },
    REINVITE_DIRECTOR_FAILED: {
      on: {
        START: { target: 'REINVITE_DIRECTOR' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
